const CZ = { id: "country-001-cz", name: "Česká republika" };

export const whoLooked = [
  {
    id: "wl-001",
    person: {
      firstName: "Jana",
      lastName: "Nováková",
      birthDate: "1985-03-12",
      databox: "abc12345",
      email: "jana.novakova@example.cz",
      address: {
        country: CZ,
        municipality: { id: "muni-001-praha", name: "Praha" },
        municipalityId: "muni-001-praha",
        street: "Wenceslas",
        orientationNumber: "22",
        zip: "11000",
      },
      deliveryAddress: {
        country: CZ,
        municipality: { id: "muni-001-praha", name: "Praha" },
        municipalityId: "muni-001-praha",
        street: "Wenceslas",
        orientationNumber: "22",
        zip: "11000",
      },
    },
    legalPerson: null,
    text: "Nahlédnutí do oznámení o majetku",
    attachments: [],
    created: "2026-03-01T10:00:00.000Z",
  },
  {
    id: "wl-002",
    person: {
      firstName: "Petr",
      lastName: "Svoboda",
      birthDate: "1972-07-25",
      databox: "xyz98765",
      email: "petr.svoboda@firma.cz",
      address: {
        country: CZ,
        municipality: { id: "muni-002-brno", name: "Brno" },
        municipalityId: "muni-002-brno",
        street: "Masarykova",
        orientationNumber: "10",
        zip: "60200",
      },
      deliveryAddress: {
        country: CZ,
        municipality: { id: "muni-002-brno", name: "Brno" },
        municipalityId: "muni-002-brno",
        street: "Husova",
        orientationNumber: "5",
        zip: "60200",
      },
    },
    legalPerson: {
      name: "Svoboda & Partneři s.r.o.",
      identificationNumber: "12345678",
      address: {
        country: CZ,
        municipality: { id: "muni-002-brno", name: "Brno" },
        municipalityId: "muni-002-brno",
        street: "Masarykova",
        orientationNumber: "10",
        zip: "60200",
      },
    },
    text: "Kontrola pro právní zastoupení",
    attachments: [],
    created: "2026-03-10T14:30:00.000Z",
  },
];
